module.exports = __webpack_public_path__ + "img/bind-alipay-1550630940566781.5d3095f5.png";